import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['announcedRadioButton', 'refusedRadioButton', 'submitButton', 'overlayUnselected']

  connect () {
    // 初期値が仮キープのものはオーバレイしない
    this.announcedRadioButtonTargets.forEach(
      announcedRadioButton => {
        if (announcedRadioButton.defaultChecked === true) {
          const overlayId = `overlay_${announcedRadioButton.id.split('_')[1]}`
          const overlayTarget = this.overlayUnselectedTargets.find(x => x.id === overlayId)
          overlayTarget.classList.add('hidden')
        }
      }
    )
  }

  refused () {
    const refusedDates = this.refusedRadioButtonTargets
      .filter(x => x.checked === true && x.getAttribute('data-status') !== 'refused' && x.getAttribute('data-date') !== '')
      .map(x => x.getAttribute('data-date'))
    if (refusedDates.length) {
      this.submitButtonTarget.setAttribute('data-text', `以下の日程全ては弊社事由キャンセルになりますがよろしいですか？<br>${refusedDates.join('<br>')}`)
      this.submitButtonTarget.setAttribute('data-icon', 'warning')
    } else {
      this.submitButtonTarget.setAttribute('data-text', '更新してもよろしいですか？')
      this.submitButtonTarget.removeAttribute('data-icon')
    }
  }

  toggleOverlay ({ params }) {
    const overlayUnselectedTargets = this.overlayUnselectedTargets
    const overlayTarget = overlayUnselectedTargets.find(x => x.id === params.overlay)
    if (params.status === 'announced') {
      overlayTarget.classList.add('hidden')
    } else {
      overlayTarget.classList.remove('hidden')
    }
  }
}
